export const INTAKE_FORM_CONTAINER_ID = 'INTAKE-FORM-PANEL';
export const INTAKE_FORM_SECTION_ID = 'INTAKE-FORM-SECTION';
